type ClawPassInfo = {
  valid_from?: string;
  valid_to?: string;
  claw_pass_plan_type?: string;
} | null;

/**
 * 根据任务创建时间与用户当前 claw-pass 有效期范围返回 badge 配色 className：
 * - 创建时间落在有效期内、且 plan_type 为明确的 pass 版本 → 按版本区分（claw_pass_pro: 橙红，claw_pass_basic: 金色）
 * - 否则（不在有效期内 / plan_type 为 unspecified 等非 pass 版本）→ 中性色
 *
 * 只返回随版本变化的 bg/text 颜色 class 字面量（写死以便 JIT 静态扫描），
 * 固定的透明度等样式由调用方在 JSX 静态 className 里给。
 */
export function getClawPassBadgeClassName(taskCreatedAt: Date, clawPass: ClawPassInfo): string {
  const NEUTRAL = 'bg-[#8e8e8e] text-[#8e8e8e]';
  const { valid_from, valid_to, claw_pass_plan_type } = clawPass ?? {};
  const inRange =
    !!valid_from &&
    !!valid_to &&
    taskCreatedAt.getTime() >= new Date(valid_from).getTime() &&
    taskCreatedAt.getTime() <= new Date(valid_to).getTime();
  if (!inRange) return NEUTRAL;
  if (claw_pass_plan_type === 'claw_pass_pro') return 'bg-[#d7672a] text-[#d7672a]';
  if (claw_pass_plan_type === 'claw_pass_basic') return 'bg-[#ba9d64] text-[#ba9d64]';
  return NEUTRAL;
}
